var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.3"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.7071 1.79289C10.3166 1.40237 9.68342 1.40237 9.29289 1.79289L2.58579 8.5L9.29289 15.2071C9.68342 15.5976 10.3166 15.5976 10.7071 15.2071C11.0976 14.8166 11.0976 14.1834 10.7071 13.7929L5.41421 8.5L10.7071 3.20711C11.0976 2.81658 11.0976 2.18342 10.7071 1.79289Z","fill":"#E8EFFF"})));
}

ArrowLeft.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
